import Column from "@components/column";
import SubCategoryForm from "./form";

import SubCategoryList from "./list";

const SubCategory = () => {
  return (
    <Column>
      <SubCategoryForm />
      <SubCategoryList />
    </Column>
  );
};

export default SubCategory;
